import * as LucideIcons from "lucide-react";
import { LucideIcon } from "lucide-react";

interface TagIconProps {
  iconName?: string;
  color?: string;
  size?: number;
  className?: string;
}

export function TagIcon({ iconName, color = "#3B82F6", size = 16, className = "" }: TagIconProps) {
  if (!iconName) {
    return (
      <div
        className={`rounded-full ${className}`}
        style={{ 
          backgroundColor: color,
          width: size,
          height: size,
          minWidth: size,
          minHeight: size
        }}
      />
    );
  }

  // Convert kebab-case to PascalCase for Lucide icon names
  const iconKey = iconName
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('');

  const IconComponent = (LucideIcons as any)[iconKey] as LucideIcon;

  if (!IconComponent) {
    // Fallback to color dot if icon not found
    return (
      <div
        className={`rounded-full ${className}`}
        style={{ 
          backgroundColor: color,
          width: size,
          height: size,
          minWidth: size,
          minHeight: size
        }}
      />
    );
  }

  return (
    <div
      className={`rounded-full flex items-center justify-center ${className}`}
      style={{ 
        backgroundColor: color,
        width: size + 8,
        height: size + 8,
        minWidth: size + 8,
        minHeight: size + 8
      }}
    >
      <IconComponent 
        size={size} 
        className="text-white" 
        strokeWidth={2}
      />
    </div>
  );
}